"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCell = exports.Table = exports.TableFieldType = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const validators_1 = require("../../../validators");
const RichText_1 = require("./RichText");
exports.TableFieldType = "Table";
const TableConfig = t.exact(t.partial({
    label: validators_1.StringOrNull,
}));
exports.Table = t.exact(t.intersection([
    t.type({
        type: t.literal(exports.TableFieldType),
    }),
    t.partial({
        config: TableConfig,
    }),
]));
exports.TableCell = {
    type: "StructuredText",
    config: {
        multi: [
            RichText_1.RichTextNodeType.paragraph,
            RichText_1.RichTextNodeType.strong,
            RichText_1.RichTextNodeType.em,
            RichText_1.RichTextNodeType.hyperlink,
        ].join(","),
    },
};
